/* ======================================================
   PRODUCT ADDON
====================================================== */

function toggleCart(variantId, button) {
  if (button.textContent === "+ Add") {
    addToCart(variantId, button);
  } else {
    removeFromCart(variantId, button);
  }
}

function addToCart(variantId, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "Added";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeFromCart(variantId, button) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "+ Add";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


/* ======================================================
   FOOTER COUNTRY SELECTOR
====================================================== */

document.addEventListener("DOMContentLoaded", function () {
  var usFlagLink = document.getElementById("flag-us");
  if (usFlagLink) {
    usFlagLink.addEventListener("click", function (event) {
      event.preventDefault();
    });
  }
});


/* ======================================================
   INFINITE ADDONS QUANTITY MATCHER
====================================================== */

$(document).ready(function () {
  $('input[name="quantity"]').on("change", function () {
    var quantity = $(this).val();

    $('select[name="addon_field"], input[name="addon_field"]').each(function () {
      $(this).attr("data-quantity", quantity);
    });
  });
});


/* ======================================================
   FIX SLIDER BUTTONS
====================================================== */

$(document).ready(function () {

  $(document).on(
    "click",
    ".featured-collection-controls .prev, .featured-collection-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="featured-collection"]');
      var $slider = $("[data-carousel-enabled]", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  $(document).on(
    "click",
    ".full-width-slideshow-controls .prev, .full-width-slideshow-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="slideshow"]');
      var $slider = $(".js-slideshow-section", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  $(document).on(
    "click",
    ".gallery-controls .prev, .gallery-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="gallery"]');
      var $slider = $(".js-gallery-slider", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

});


/* ======================================================
   BACK IN STOCK (MAILTO VERSION)
====================================================== */

(function () {
  var soldOutEl = document.getElementById('sold-out-variants-json');
  var variantsEl = document.getElementById('product-variants-json');
  var productEl = document.getElementById('product-data-json');
  var wrapper = document.getElementById('back-in-stock-wrapper');
  var emailLink = document.getElementById('back-in-stock-email-link');

  if (!soldOutEl || !variantsEl || !productEl || !wrapper || !emailLink) return;

  var soldOutVariants = [];
  var productVariants = [];
  var productData = {};

  try { soldOutVariants = JSON.parse(soldOutEl.textContent || '[]'); } catch (e) { soldOutVariants = []; }
  try { productVariants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { productVariants = []; }
  try { productData = JSON.parse(productEl.textContent || '{}'); } catch (e) { productData = {}; }

  var variantInput = document.querySelector('input[name="id"]');
  if (!variantInput) return;

  var variantDropdowns = document.querySelectorAll('.option-selector[data-single-option-selector]');

  function getCurrentVariantObject() {
    var variantId = String(variantInput.value || '');
    for (var i = 0; i < productVariants.length; i++) {
      if (String(productVariants[i].id) === variantId) return productVariants[i];
    }
    return null;
  }

  function buildMailtoHref(variant) {
    var baseMailto = (emailLink.getAttribute('href') || '').split('?')[0];
    if (!baseMailto.toLowerCase().startsWith('mailto:')) return;

    var productTitle = (productData && productData.title) ? productData.title : (document.title || '');
    var variantTitle = (variant && variant.title && String(variant.title).toLowerCase() !== 'default title')
        ? String(variant.title)
        : '';

    var variantId = (variant && variant.id) ? String(variant.id) : String(variantInput.value || '');
    var sku = (variant && variant.sku) ? String(variant.sku) : '';

    var productUrl =
      window.location.origin + window.location.pathname +
      (variantId ? ('?variant=' + encodeURIComponent(variantId)) : '');

    var subject = variantTitle
      ? ('Back in stock request – ' + productTitle + ' – ' + variantTitle)
      : ('Back in stock request – ' + productTitle);

    var bodyLines = [
      'Hi The Balcony Garden team,',
      '',
      'Could you please notify me when the item below is back in stock?',
      '',
      'Product: ' + productTitle,
      variantTitle ? ('Variant: ' + variantTitle) : null,
      sku ? ('SKU: ' + sku) : null,
      variantId ? ('Variant ID: ' + variantId) : null,
      'Link: ' + productUrl,
      '',
      'Thanks!'
    ].filter(function (line) { return line !== null && line !== undefined; });

    var body = bodyLines.join('\r\n');

    var href =
      baseMailto +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);

    emailLink.setAttribute('href', href);
  }

  function updateBackInStockUI() {
    var currentVariant = getCurrentVariantObject();
    if (!currentVariant) return;

    var variantIdNum = Number(variantInput.value);
    var isSoldOut = soldOutVariants.indexOf(variantIdNum) !== -1;

    if (isSoldOut) {
      wrapper.style.display = 'block';
      buildMailtoHref(currentVariant);
    } else {
      wrapper.style.display = 'none';
    }
  }

  if (variantDropdowns && variantDropdowns.length) {
    variantDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', updateBackInStockUI);
      dropdown.addEventListener('click', updateBackInStockUI);
    });
  }

  if (window.jQuery) {
    window.jQuery(window).on('cc-variant-updated.backInStockMailto', function () {
      updateBackInStockUI();
    });
  }

  updateBackInStockUI();
})();


/* ======================================================
   BOOST COUNTDOWN
====================================================== */

document.addEventListener("DOMContentLoaded", function () {

  const countdowns = document.querySelectorAll(".boost-countdown");
  if (!countdowns.length) return;

  countdowns.forEach(function (countdown) {

    const endDate = new Date(countdown.dataset.countdownDate).getTime();
    const showSeconds = countdown.dataset.showSeconds === "true";

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance <= 0) {
        const wrapper = countdown.closest(".boost-countdown-wrapper");
        if (wrapper) wrapper.style.display = "none";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      const daysEl = countdown.querySelector(".cd-days");
      const hoursEl = countdown.querySelector(".cd-hours");
      const minutesEl = countdown.querySelector(".cd-minutes");

      if (daysEl) daysEl.textContent = days;
      if (hoursEl) hoursEl.textContent = hours;
      if (minutesEl) minutesEl.textContent = minutes;

      if (showSeconds) {
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const secondsEl = countdown.querySelector(".cd-seconds");
        if (secondsEl) secondsEl.textContent = seconds;
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

  });

});


/* ======================================================
   PROMO COUNTDOWN
====================================================== */

document.addEventListener("DOMContentLoaded", initPromoCountdowns);
document.addEventListener("shopify:section:load", initPromoCountdowns);

function initPromoCountdowns() {

  document.querySelectorAll(".promo-countdown").forEach(function(section) {

    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    const targetDateString = section.dataset.targetDate;
    const timezoneOffset = parseInt(section.dataset.timezoneOffset || 0);
    const enableTimer = section.dataset.enableTimer === "true";

    const timerEl = section.querySelector(".promo-countdown__timer");
    const expiredEl = section.querySelector(".promo-countdown__expired");

    if (enableTimer && targetDateString && timerEl) {

      const target = new Date(targetDateString);
      target.setHours(target.getHours() + timezoneOffset);

      function updateTimer() {

        const now = new Date().getTime();
        const distance = target.getTime() - now;

        if (distance <= 0) {
          timerEl.style.display = "none";
          if (expiredEl) expiredEl.style.display = "block";
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        timerEl.innerHTML =
          '<div class="time"><span class="number">' + String(days).padStart(2,'0') + '</span><span class="label">Days</span></div>' +
          '<div class="time"><span class="number">' + String(hours).padStart(2,'0') + '</span><span class="label">Hours</span></div>' +
          '<div class="time"><span class="number">' + String(minutes).padStart(2,'0') + '</span><span class="label">Minutes</span></div>' +
          '<div class="time"><span class="number">' + String(seconds).padStart(2,'0') + '</span><span class="label">Seconds</span></div>';
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    }

    const form = section.querySelector(".promo-countdown__form");
    const success = section.querySelector(".promo-countdown__success");

    if (form) {
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        fetch(form.action, {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "text/html" }
        }).then(function() {
          form.style.display = "none";
          if (success) success.style.display = "block";
        });
      });
    }

  });

}